
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/code",
      function () {
        return require("private-next-pages/legal/code.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/code"])
      });
    }
  